import CustomSpin from '../../../elements/CustomSpin'
import useFetchURL from '../../../elements/Hooks/useFetchURL'
import InfoTooltip from '../../../elements/InfoTooltip'
import CustomDebounceSelect from '../../../elements/Select/CustomDebounceSelect'
import React, { useState } from 'react'
import { Checkbox, Col, Divider, Form, Input, Row } from 'antd'
import _, { get, isEmpty } from 'lodash'
import { strVal } from '../../../modules/Utils'

import { defaultFormItemLayout, rules, threeFormItemLayout } from '../../../modules/FormItems'
import withSpinning from '../../../elements/HOC/withSpinning'
import { compose } from 'recompose'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import withUrlFetch from '../../../elements/Select/withUrlFetch'
import withFormItemView from 'form-item-view-hoc'

const CustomFormItem = compose(withFormItemView)(Form.Item)

const { TextArea } = Input

const VendorSelect = compose(
  withUrlFetch({
    name: 'members',
    url: `members/list/organisation`,
  }),
  withSpinning,
)(CustomDebounceSelect)

const VQLCell = (props) => {
  const { vql, i, vq, requisition, getFieldDecorator, getFieldValue, salesLines } = props

  const enquiryId = _.get(vq, 'enquiry._id') || ''
  const budgetKey = get(requisition, 'budget._key')
  const isImport = getFieldValue(`line[${i}]import`)
  const salesOrderLinePreset = strVal(
    salesLines.find((l) => strVal(l, 'enquiry._id') === strVal(vql, `enquiryLines._id`)),
    '._id',
  )
  console.log({ salesOrderLinePreset })
  const [EnquiryLinesSelect] = useFetchSelectUrl(
    {
      name: 'enquiriesLines',
      url: `/enquiries/lines/${enquiryId.replace('activities/', '')}`,
      cache: true,
      forceFetch: false,
    },
    [enquiryId],
    isEmpty(enquiryId),
    undefined,
    (c) => ({
      ...c,
      display: `${strVal(c, 'name')} - ${strVal(c, 'description')}`,
    }),
  )

  const [BudgetLinesSelect] = useFetchSelectUrl(
    {
      name: 'budgetsLines',
      url: `budgets/${budgetKey}/lines`,
      cache: true,
    },
    [budgetKey],
  )

  const salesKey = get(requisition, 'sales._key')
  const [OrderLinesSelect] = useFetchSelectUrl(
    {
      name: 'OrderLinesSelect',
      url: `sales/${salesKey}/lines`,
      cache: true,
    },
    [salesKey],
  )

  return (
    <Row>
      <Divider orientation="left">
        Import:{' '}
        {getFieldDecorator(`line[${i}]import`, {
          initialValue: true,
          valuePropName: 'checked',
        })(<Checkbox/>)}
        {'     '}({[get(vql, 'no'), get(vql, 'name'), get(vql, 'description')].join('  -  ')})
      </Divider>

      {getFieldDecorator(`line[${i}]vendorQuoteLine._id`, {
        initialValue: vql._id,
      })(<span/>)}

      {isImport && (
        <>
          <Row>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label={'Name'}>
                {getFieldDecorator(`line[${i}]name`, {
                  initialValue: get(vql, `name`),
                  rules: rules.input,
                })(<Input placeholder={'Name'}/>)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label={'Unit'}>
                {getFieldDecorator(`line[${i}]unit`, {
                  initialValue: get(vql, `unit`),
                  rules: rules.input,
                })(<Input placeholder={'unit'}/>)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <CustomFormItem readOnly={true} {...threeFormItemLayout} label={'Rate'}>
                {getFieldDecorator(`line[${i}]rate`, {
                  initialValue: get(vql, `rate`),
                  rules: rules.input,
                })(<Input placeholder={'Name'}/>)}
              </CustomFormItem>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label={'Sub-Component'}>
                {getFieldDecorator(`line[${i}]isSubcomponents`, {
                  initialValue: false,
                  valuePropName: 'checked',
                })(<Checkbox/>)}
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label={'TO Stock'}>
                {getFieldDecorator(`line[${i}]toStock`, {
                  valuePropName: 'checked',
                })(<Checkbox placeholder={'To Stock'}/>)}
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                {...threeFormItemLayout}
                label={
                  <InfoTooltip
                    value={'Sales Order Line'}
                    title={'Sales Order Line that this requisition relates to.'}
                  />
                }>
                {getFieldDecorator(`line[${i}]orderLine._id`, {
                  initialValue: salesOrderLinePreset,
                })(<OrderLinesSelect keyAtr={'_id'} valueAtr={'name'}/>)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label="Budget Lines">
                {getFieldDecorator(`line[${i}]budgetLine._id`, {
                  initialValue: get(vql, `budgetLine._id`),
                  rules: rules.input,
                })(<BudgetLinesSelect data-testid={`line[${i}]budgetLine._id`} keyAtr={'_id'} valueAtr={'name'}/>)}
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
    </Row>
  )
}

function RequisitionsForm (props) {
  let { requisition } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form

  const vendor = getFieldValue('vendor._id') || ''
  const vendorQuote = getFieldValue('vendorQuote._id') || ''
  const [vq, setVq] = useState({})
  const salesKey = get(requisition, 'sales._key')

  const vendorQuotesURL = vendor
    ? `vendorQuotes/?owner=${vendor.replace('members/', '')}&select=_id,title,enquiry`
    : `vendorQuotes/?select=_id,title,enquiry`

  const [VendorQuoteSelect] = useFetchSelectUrl(
    {
      name: 'vendorQuotes',
      url: vendorQuotesURL,
    },
    [vendor],
  )

  const { data: vendorQuoteLines, fetching: fetchingVQL, fetchURL: fetchVQL } = useFetchURL(
    `foxxapi/vendorQuotes/lines/${vendorQuote.replace('spquotes/', '')}`,
    [vendorQuote],
    isEmpty(vendorQuote),
    undefined,
    true,
  )

  const { data: salesLines, fetching: fetchingSL, fetchURL: fetchSL } = useFetchURL(
    `foxxapi/sales/${salesKey}/lines`,
    [salesKey],
    isEmpty(salesKey),
    undefined,
    true,
  )

  console.log({ vq })

  return (
    <CustomSpin spinning={fetchingVQL}>
      <Form>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Vendor'}>
              {getFieldDecorator('vendor._id', {
                initialValue: get(requisition, 'vendor._id'),
              })(
                <VendorSelect
                  keyAtr={'_id'}
                  valueAtr={'fn'}
                  placeholder="Select a Vendor Quote"
                  style={{ width: '100%' }}
                />,
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Vendor Quote'}>
              {getFieldDecorator('vendorQuote._id', {
                initialValue: get(requisition, 'vendorQuote._id'),
              })(
                <VendorQuoteSelect
                  keyAtr={'_id'}
                  valueAtr={'title'}
                  setSelected={setVq}
                  placeholder="Select a Vendor Quote"
                  style={{ width: '100%' }}
                />,
              )}
            </Form.Item>
          </Col>
        </Row>

        {/*// {vendorQuoteLines.length > 0 && (*/}
        {vendorQuoteLines.map((vql, i) => (
          <VQLCell
            {...{
              vql,
              vq,
              i,
              requisition,
              getFieldValue,
              salesLines,
              getFieldDecorator,
            }}
          />
        ))}
      </Form>
    </CustomSpin>
  )
}

RequisitionsForm.propTypes = {}
RequisitionsForm.defaultProps = {}

export default Form.create()((RequisitionsForm))
